var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_25026)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#3152E7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0, 4)",
    d: "M17.5 22.125C22.2635 22.125 26.125 18.2635 26.125 13.5C26.125 8.73654 22.2635 4.875 17.5 4.875C12.7365 4.875 8.875 8.73654 8.875 13.5C8.875 18.2635 12.7365 22.125 17.5 22.125Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0, 4)",
    d: "M20.1833 10.6254C20.0097 10.3243 19.7575 10.076 19.4536 9.90721C19.1498 9.7384 18.8057 9.65541 18.4583 9.6671H16.5417C16.0333 9.6671 15.5458 9.86904 15.1864 10.2285C14.8269 10.5879 14.625 11.0754 14.625 11.5838C14.625 12.0921 14.8269 12.5796 15.1864 12.9391C15.5458 13.2985 16.0333 13.5004 16.5417 13.5004H18.4583C18.9667 13.5004 19.4542 13.7024 19.8136 14.0618C20.1731 14.4213 20.375 14.9088 20.375 15.4171C20.375 15.9254 20.1731 16.4129 19.8136 16.7724C19.4542 17.1318 18.9667 17.3338 18.4583 17.3338H16.5417C16.1943 17.3455 15.8502 17.2625 15.5464 17.0937C15.2425 16.9248 14.9903 16.6766 14.8167 16.3754",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0, 4)",
    d: "M17.5 7.75V9.66667M17.5 17.3333V19.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_25026",
    x: 0,
    y: 0,
    width: 35,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_25026"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_25026",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarDashboardIcon);
export default __webpack_public_path__ + "static/media/dollar-dashboard-icon.dd2743f65677d1eeebd6ded4dff05144.svg";
export { ForwardRef as ReactComponent };